"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayCommand = void 0;
class RelayCommand {
    constructor(shouldRun, run) {
        this.shouldRun = shouldRun;
        this.run = run;
    }
}
exports.RelayCommand = RelayCommand;
//# sourceMappingURL=RelayCommand.js.map